(() => {
  // src/lib/filter-request.ts
  var stripPageParam = (urlString) => {
    const url = new URL(urlString, window.location.origin);
    url.searchParams.delete("page");
    return url.toString();
  };

  // src/collection-toolbar.ts
  (() => {
    const PANEL_TRANSITION_MS = 320;
    const checkIconTemplate = document.getElementById("filter-check-icon");
    let filterPanelOpen = false;
    let activeFetch = null;
    const openFilterPanel = (animate = true) => {
      var _a;
      const panel = document.getElementById("filter-panel");
      const backdrop = document.getElementById("filter-panel-backdrop");
      if (!panel) return;
      panel.removeAttribute("hidden");
      backdrop == null ? void 0 : backdrop.removeAttribute("hidden");
      if (!animate) {
        panel.style.transition = "none";
        if (backdrop) backdrop.style.transition = "none";
      }
      void panel.offsetWidth;
      panel.classList.add("is-open");
      backdrop == null ? void 0 : backdrop.classList.add("is-open");
      if (!animate) {
        void panel.offsetWidth;
        panel.style.transition = "";
        if (backdrop) backdrop.style.transition = "";
      }
      panel.setAttribute("aria-hidden", "false");
      (_a = document.querySelector(".collection-toolbar__filter")) == null ? void 0 : _a.setAttribute("aria-expanded", "true");
      filterPanelOpen = true;
    };
    const closeFilterPanel = () => {
      var _a;
      const panel = document.getElementById("filter-panel");
      const backdrop = document.getElementById("filter-panel-backdrop");
      if (!panel) return;
      panel.classList.remove("is-open");
      backdrop == null ? void 0 : backdrop.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      (_a = document.querySelector(".collection-toolbar__filter")) == null ? void 0 : _a.setAttribute("aria-expanded", "false");
      setTimeout(() => {
        panel.setAttribute("hidden", "");
        backdrop == null ? void 0 : backdrop.setAttribute("hidden", "");
      }, PANEL_TRANSITION_MS);
      filterPanelOpen = false;
    };
    const syncPriceSlider = (container) => {
      const minThumb = container.querySelector("[data-price-thumb-min]");
      const maxThumb = container.querySelector("[data-price-thumb-max]");
      const track = container.querySelector("[data-price-track]");
      if (!minThumb || !maxThumb || !track) return;
      const rangeMin = parseFloat(minThumb.min);
      const rangeMax = parseFloat(minThumb.max);
      const minPct = (parseFloat(minThumb.value) - rangeMin) / (rangeMax - rangeMin) * 100;
      const maxPct = (parseFloat(maxThumb.value) - rangeMin) / (rangeMax - rangeMin) * 100;
      track.style.background = `linear-gradient(to right,
      var(--color-light-gray, #e0e0e0) ${minPct}%,
      var(--color-dark-gray) ${minPct}%,
      var(--color-dark-gray) ${maxPct}%,
      var(--color-light-gray, #e0e0e0) ${maxPct}%)`;
    };
    const syncThumbsFromFields = (container) => {
      const minField = container.querySelector("[data-price-field-min]");
      const maxField = container.querySelector("[data-price-field-max]");
      const minThumb = container.querySelector("[data-price-thumb-min]");
      const maxThumb = container.querySelector("[data-price-thumb-max]");
      if (minThumb && minField) minThumb.value = minField.value;
      if (maxThumb && maxField) maxThumb.value = maxField.value;
    };
    const fetchFilteredPage = async (url) => {
      var _a, _b, _c, _d;
      activeFetch == null ? void 0 : activeFetch.abort();
      const controller = new AbortController();
      activeFetch = controller;
      try {
        const res = await fetch(url, { signal: controller.signal });
        const text = await res.text();
        if (activeFetch !== controller) return;
        const doc = new DOMParser().parseFromString(text, "text/html");
        const newGrids = doc.querySelectorAll(".collection__grid");
        document.querySelectorAll(".collection__grid").forEach((oldGrid, i) => {
          if (newGrids[i]) oldGrid.innerHTML = newGrids[i].innerHTML;
        });
        (_b = (_a = window.HotelCollection) == null ? void 0 : _a.fadeInCollectionGrids) == null ? void 0 : _b.call(_a);
        const wasOpen = filterPanelOpen;
        const newPanel = doc.getElementById("filter-panel");
        const newBackdrop = doc.getElementById("filter-panel-backdrop");
        (_c = document.getElementById("filter-panel-backdrop")) == null ? void 0 : _c.replaceWith(newBackdrop != null ? newBackdrop : document.createElement("div"));
        (_d = document.getElementById("filter-panel")) == null ? void 0 : _d.replaceWith(newPanel != null ? newPanel : document.createElement("div"));
        if (wasOpen) openFilterPanel(false);
        document.querySelectorAll("[data-price-range]").forEach(syncPriceSlider);
        history.pushState({ ajaxUrl: url }, "", url);
      } catch (err) {
        if (err.name === "AbortError") return;
        window.location.href = url;
      }
    };
    const applyPriceFilter = (container) => {
      const minField = container.querySelector("[data-price-field-min]");
      const maxField = container.querySelector("[data-price-field-max]");
      const minParam = container.dataset.minParam;
      const maxParam = container.dataset.maxParam;
      if (!minField || !maxField || !minParam || !maxParam) return;
      const url = new URL(window.location.href);
      url.searchParams.set(minParam, String(Math.round(parseFloat(minField.value))));
      url.searchParams.set(maxParam, String(Math.round(parseFloat(maxField.value))));
      url.searchParams.delete("page");
      void fetchFilteredPage(url.toString());
    };
    document.addEventListener("click", (e) => {
      var _a, _b;
      const target = e.target;
      if (target.closest(".collection-toolbar__filter")) {
        openFilterPanel();
        return;
      }
      if (target.closest("[data-filter-panel-close]")) {
        closeFilterPanel();
        return;
      }
      const filterLink = target.closest("[data-filter-url]");
      if (filterLink && ((_a = document.getElementById("filter-panel")) == null ? void 0 : _a.contains(filterLink))) {
        e.preventDefault();
        const checkbox = filterLink.querySelector(".search-filter-panel__checkbox");
        if (checkbox) {
          const nowActive = !checkbox.classList.contains("is-active");
          checkbox.classList.toggle("is-active", nowActive);
          checkbox.innerHTML = "";
          if (nowActive && checkIconTemplate) checkbox.appendChild(checkIconTemplate.content.cloneNode(true));
        }
        void fetchFilteredPage(stripPageParam(filterLink.href));
        return;
      }
      if (target.closest("[data-filter-clear-all]") && ((_b = document.getElementById("filter-panel")) == null ? void 0 : _b.contains(target))) {
        e.preventDefault();
        const url = new URL(window.location.href);
        [...url.searchParams.keys()].filter((k) => k.startsWith("filter.")).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete("page");
        void fetchFilteredPage(url.toString());
        return;
      }
    });
    document.addEventListener("dropdown:change", (e) => {
      if (!e.target.closest(".collection-toolbar__sort")) return;
      e.stopImmediatePropagation();
      const sortValue = e.detail.value;
      if (!sortValue) return;
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortValue);
      url.searchParams.delete("page");
      void fetchFilteredPage(url.toString());
    }, true);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && filterPanelOpen) closeFilterPanel();
    });
    document.addEventListener("input", (e) => {
      const target = e.target;
      const minThumb = target.closest("[data-price-thumb-min]");
      if (minThumb) {
        const container = minThumb.closest("[data-price-range]");
        if (!container) return;
        const field = container.querySelector("[data-price-field-min]");
        if (field) field.value = minThumb.value;
        syncPriceSlider(container);
        return;
      }
      const maxThumb = target.closest("[data-price-thumb-max]");
      if (maxThumb) {
        const container = maxThumb.closest("[data-price-range]");
        if (!container) return;
        const field = container.querySelector("[data-price-field-max]");
        if (field) field.value = maxThumb.value;
        syncPriceSlider(container);
      }
    });
    document.addEventListener("change", (e) => {
      const target = e.target;
      const priceThumb = target.closest("[data-price-thumb-min], [data-price-thumb-max]");
      if (priceThumb) {
        const container = priceThumb.closest("[data-price-range]");
        if (container) applyPriceFilter(container);
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      const target = e.target;
      const priceField = target.closest("[data-price-field-min], [data-price-field-max]");
      if (priceField) {
        const container = priceField.closest("[data-price-range]");
        if (container) {
          syncThumbsFromFields(container);
          syncPriceSlider(container);
          applyPriceFilter(container);
        }
      }
    });
    document.querySelectorAll("[data-price-range]").forEach(syncPriceSlider);
  })();
})();
